// NYCC Exclusive Product Cards
document.addEventListener('DOMContentLoaded', function () {
  if (!document.body.classList.contains('nycc-exclusive-collection')) return;

  function updateCardImage(card, swatch) {
    if (!swatch) return;
    const mainImg = card.querySelector('.card-main-image, .card__media img');
    const newSrc = swatch.getAttribute('data-variant-image');

    if (mainImg && newSrc) {
      mainImg.src = newSrc;
      if (mainImg.srcset) {
        mainImg.removeAttribute('srcset');
      }
    }
  }

  function updateSizeQuantities(card, selectedColor) {
    const jsonScript = card.querySelector('.product-card-variants-json');
    if (!jsonScript || !selectedColor) return;

    let variantMap = {};
    try {
      variantMap = JSON.parse(jsonScript.textContent);
    } catch (e) {
      return;
    }

    const sizeItems = card.querySelectorAll('[data-size-item]');
    sizeItems.forEach(sizeEl => {
      const sizeValue = sizeEl.getAttribute('data-size-item');
      const key1 = `${selectedColor} / ${sizeValue}`;
      const key2 = `${sizeValue} / ${selectedColor}`;
      const variantData = variantMap[key1] || variantMap[key2];

      if (variantData) {
        const qty = variantData.quantity;
        const policy = variantData.policy || 'deny';
        const isAvailable = variantData.available;

        sizeEl.setAttribute('data-quantity', qty);
        sizeEl.setAttribute('data-policy', policy);
        sizeEl.setAttribute('data-available', isAvailable);

        if (isAvailable) {
          sizeEl.classList.remove('is-out-of-stock');
        } else {
          sizeEl.classList.add('is-out-of-stock');
        }
      }
    });
  }

  function updateCardInventory(card, item) {
    const inventoryDiv = card.querySelector('[data-card-inventory]');
    if (!inventoryDiv || !item) return;

    const isColor = item.hasAttribute('data-color-swatch');

    if (isColor) {
      const selectedColor = item.getAttribute('data-color-swatch');
      updateCardImage(card, item);
      updateSizeQuantities(card, selectedColor);
    }

    let activeItem = item;
    if (isColor) {
      const activeSize = card.querySelector('[data-size-item].is-selected') || card.querySelector('[data-size-item]');
      if (activeSize) activeItem = activeSize;
    }

    const quantity = parseInt(activeItem.getAttribute('data-quantity'), 10) || 0;
    const policy = activeItem.getAttribute('data-policy') || 'deny';
    const isAvailable = activeItem.getAttribute('data-available') === 'true';

    inventoryDiv.classList.remove('is-in-stock', 'is-low-stock', 'is-out-of-stock');

    if (isAvailable && (quantity > 5 || policy === 'continue')) {
      inventoryDiv.classList.add('is-in-stock');
      inventoryDiv.innerHTML = '<span class="in-stock">In Stock</span>';
    } else if (isAvailable && quantity > 0) {
      inventoryDiv.classList.add('is-low-stock');
      inventoryDiv.innerHTML = '<span class="low-stock">Low Stock</span>';
    } else {
      inventoryDiv.classList.add('is-out-of-stock');
      inventoryDiv.innerHTML = '<span class="out-of-stock">Out of Stock</span>';
    }
  }

  const allCards = document.querySelectorAll('.card-wrapper, .product-card');
  allCards.forEach(card => {
    const firstColor = card.querySelector('[data-color-swatch]');
    if (firstColor) {
      firstColor.classList.add('is-selected', 'opaque');
      const colorValue = firstColor.getAttribute('data-color-swatch');
      updateCardImage(card, firstColor);
      updateSizeQuantities(card, colorValue);
    }

    const firstSize = card.querySelector('[data-size-item]');
    if (firstSize) {
      firstSize.classList.add('is-selected');
      updateCardInventory(card, firstSize);
    }
  });

  document.addEventListener('click', function (event) {
    const targetItem = event.target.closest('[data-size-item], [data-color-swatch]');
    if (!targetItem) return;

    const card = targetItem.closest('.card-wrapper, .product-card');
    if (!card) return;

    const isColor = targetItem.hasAttribute('data-color-swatch');
    const selector = isColor ? '[data-color-swatch]' : '[data-size-item]';

    card.querySelectorAll(selector).forEach(el => el.classList.remove('is-selected', 'opaque'));
    targetItem.classList.add('is-selected');
    if (isColor) targetItem.classList.add('opaque');

    updateCardInventory(card, targetItem);
  });
});